import { PropsWithChildren, ReactNode } from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";

import { GamificationModalContainerStyled } from "./styles";

export const GamificationModalContainer = ({
  children,
}: PropsWithChildren<ReactNode>) => {
  return (
    <GamificationModalContainerStyled>
      <ComponentErrorBoundary>{children}</ComponentErrorBoundary>
    </GamificationModalContainerStyled>
  );
};
